import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { CountryModel } from 'ng-voxloud';
import { Subscription } from 'rxjs';
import { WIFI_VALUES } from 'src/app/domains/sales/activation-link/models/activation-link.model';
import { servedCountriesList, ServedCountriesModel } from 'src/app/domains/sales/trial-link/models/served-countries.models';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'gdp-generate-link-form',
  templateUrl: './generate-link-form.component.html',
  styleUrls: ['./generate-link-form.component.scss']
})
export class GenerateLinkFormComponent implements OnInit {
  public form: UntypedFormGroup;
  public countries: CountryModel[] = environment.servedCountries;
  public language: string;
  public wifiList: string[] = WIFI_VALUES;
  public isWifiDisabled: boolean = false;
  private subscriptions: Subscription[] = [];
  public languages = environment.supportedLanguages;

  @Output() emitValue: EventEmitter<string> = new EventEmitter();

  constructor(private fb: UntypedFormBuilder, private translateService: TranslateService) { }

  ngOnInit() {
    this.language = this.translateService.currentLang;
    this.subscriptions.push(
      this.translateService.onLangChange.subscribe((event: LangChangeEvent) => {
        this.language = event.lang;
      })
    );

    this.form = this.fb.group({
      country: [''],
      coupon: ['', Validators.required],
      language: [this.languages[0]],
      wifi: [this.wifiList[0]]
    });

    this.subscriptions.push(
      this.form.controls.country.valueChanges.subscribe((country: { iso2: string }) => {
        if (country.iso2 === 'IT') {
          this.isWifiDisabled = false;
        } else {
          this.form.controls.wifi.patchValue(this.wifiList[0]);
          this.isWifiDisabled = true;
        }
      })
    )
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  isFieldInvalid(name: string) {
    return (
      this.form.get(name).invalid && this.form.get(name).dirty
    );
  }

  onSelectLanguage(language) {
    this.form.patchValue({ language })
  }

  onSelectWifi(wifi: string) {
    this.form.patchValue({ wifi });
  }

  generateLink() {
    if (this.form.valid) {
      const value = this.form.value;
      const base64Coupon = btoa(JSON.stringify({ coupon: value.coupon }));
      const language = value.language.locale.toLowerCase();
      const country = value.country.iso2;
      const params = `?offer_id=${base64Coupon}&lang=${language}&country=${country}`;
      let link: string;
      if (value.wifi === 'none') {
        switch (value.country.iso2) {
          case 'IT':
            link = `${environment.limitedOfferLink.prefixItalian}${params}`;
            break;
          case 'GB':
          case 'US':
            link = `${environment.limitedOfferLink.prefixEnglish}${params}`;
            break;
          default:
            link = `${environment.limitedOfferLink.prefixEnglish}${params}`;
            break;
        }
      } else {
        link = value.wifi === 'simple'
          ? `${environment.limitedOfferLink.withWifiPrefix}${params}`
          : `${environment.limitedOfferLink.withWifiFullPrefix}${params}`;
      }
      this.emitValue.emit(link);
    }
  }

}
